export const allManufacturers = (data) => (dispatch) => {
    dispatch({ type: "ALL_MANUFACTURERS", payload: data });
};
export const setSearchTerm = (data) => (dispatch) => {
    dispatch({ type: "SEARCH_TERM", payload: data })
}
export const setAllReturnOrders = (data) => (dispatch) => {
    dispatch({ type: "ALL_RETURN_ORDERS", payload: data })
}
export const setAllRequests = (data) => (dispatch) => {
    dispatch({ type: "ALL_LEAVE_REQUESTS", payload: data })
}
export const allLabels = (data) => (dispatch) => {
    dispatch({ type: "ALL_LABELS", payload: data });
};
export const allNotifications = (data) => (dispatch) => {
    dispatch({ type: "ALL_NOTIFICATIONS", payload: data });
};
export const allTrackings = (data) => (dispatch) => {
    dispatch({ type: "ALL_TRACKINGS", payload: data });
}
export const setUser = (user) => (dispatch) => {
    dispatch({ type: "SIGN_UP_USER", payload: user });
};
export const setAllUsers = (users) => (dispatch) => {
    dispatch({ type: "SET_ALL_USERS", payload: users });
};
export const AllSaleOrders = (orders) => (dispatch) => {
    dispatch({ type: "ALL_SALE_ORDERS", payload: orders });
};
export const allCustomers = (customers) => (dispatch) => {
    dispatch({ type: "ALL_CUSTOMERS", payload: customers });
};
export const allVendors = (vendors) => (dispatch) => {
    dispatch({ type: "ALL_VENDORS", payload: vendors });
};
export const allPurchaseOrders = (orders) => (dispatch) => {
    dispatch({ type: "ALL_PURCHASE_ORDERS", payload: orders });
};
export const AllProducts = (data) => (dispatch) => {
    dispatch({ type: "ALL_PRODUCTS", payload: data });
};
export const AllQuotes = (quotes) => (dispatch) => {
    dispatch({ type: "ALL_QUOTES", payload: quotes });
};
export const AllCategories = (data) => (dispatch) => {
    dispatch({ type: "ALL_CATEGORIES", payload: data });
};
export const AllSubCategories = (data) => (dispatch) => {
    dispatch({ type: "ALL_SUB_CATEGORIES", payload: data });
};
export const AllAllowedManufacturers = (data) => (dispatch) => {
    dispatch({ type: "ALL_ALLOWED_MANUFACTURERS", payload: data });
};
export const AllDashboardStats = (data) => (dispatch) => {
    dispatch({ type: "ALL_STATS", payload: data });
};
export const setLayout = (layout) => (dispatch) => {
    dispatch({ type: "SET_LAYOUT", payload: layout });
};
export const setThemeColor = (color) => (dispatch) => {
    dispatch({ type: "SET_THEME_COLOR", payload: color });
};
